import React from "react";
import { Typography, Box } from "@mui/material";

const UserAgreement = () => (
    <Box sx={{ padding: '20px' }}>
        <Typography variant="h5" component="h1" gutterBottom>
            Laadu Terms of Service
        </Typography>
        <Typography variant="body1" paragraph>
            Welcome to Laadu, Inc. (also known as QuizAcer. Our website and apps (our "Service") are operated by Laadu, Inc. By using our Service, you agree to these Terms, as well as our Privacy Promise, Learning Code, and Integrity Pledge, which are part of this agreement.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
            Who Can Use Laadu
        </Typography>
        <Typography variant="body1" paragraph>
            You must be at least 13 to use Laadu. By signing up, you promise that your registration info (like name and email) is accurate, you'll keep it updated, and your use of Laadu follows all laws.
        </Typography>
        <Typography variant="body1" paragraph>
            Your account is for you alone-don't share it with others. You're responsible for keeping your account secure and for anything that happens under it. If you notice any unauthorized use, contact us immediately at laaduhelp@yahoo.com. Laadu isn't responsible for any issues caused by your actions or failure to secure your account.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
            Subscriptions and Payments
        </Typography>
        <Typography variant="body1" paragraph>
            You can buy a Subscription plan for extra features. You can pay monthly or prepay for a set period, and prepaid plans end when the period is over. Group Orders let you buy discounted subscription credits for multiple users, but you're responsible for distributing them. Once a subscription is activated, it can't be transferred or refunded (unless required by law).
        </Typography>
        <Typography variant="body1" paragraph>
            You can cancel your Subscription anytime by emailing to laaduhelp@yahoo.com. For auto-renewing plans, cancel at least one day before renewal to avoid extra charges. Subscriptions bought through other platforms (like app stores) follow their refund rules, not ours. We may change Subscription prices, but we'll notify you in advance, and changes apply at your next renewal.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
            Your Content and Responsibilities
        </Typography>
        <Typography variant="body1" paragraph>
            You're responsible for anything you post on Laadu (like study sets, text, images, or audio-called "Content"). Content must be study-related and educational. You can't post anything that:
        </Typography>
        <Typography variant="body1" component="ul" sx={{ listStyleType: 'disc', pl: 4 }}>
            <li>
                <Typography variant="body1" component="div">
                    Promotes racism, hatred, or harm against any group or person.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    Harasses or bullies anyone.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    Contains offensive, violent, or sexually suggestive material.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    Violates someone's privacy, copyrights, or other rights.
                </Typography>
            </li>
        </Typography>
        <Typography variant="body1" paragraph>
            Prohibited actions include illegal activities (like fraud or sharing harmful files), hacking, impersonating others, or using automated scripts to post Content. By posting Content, you give Laadu a worldwide, permanent, royalty-free license to use, copy, share, or modify it for our Service.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
            Handling Disputes
        </Typography>
        <Typography variant="body1" paragraph>
            If you have a dispute with Laadu, we'll try to resolve it informally for 30 days. If that doesn't work, disputes go to binding arbitration in Middlesex County, New Jersey, meaning no judge or jury trial. Exceptions include claims about copyrights, patents, or trademarks, which can go to court, or small claims court cases.
        </Typography>
        <Typography variant="body1" paragraph>
            These Terms are governed by New Jersey law. Any legal action (not covered by arbitration) must happen in state or federal courts in Middlesex County, New Jersey.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
            Disclaimers and Liability
        </Typography>
        <Typography variant="body1" paragraph>
            All Content on Laadu is provided "as is" without guarantees. You use or download Content at your own risk. Laadu, its suppliers, and partners aren't responsible for any direct, indirect, or special damages caused by using our Service.
        </Typography>
        <Typography variant="body1" paragraph>
            If you make a claim against Laadu, our liability is limited to what you paid us in the 12 months before the claim. We're not liable for any other losses or damages.
        </Typography>
    </Box>
);

export default UserAgreement;